import { ShiftSegment } from "types/types";

export type ReportItemProps = {
  initialExpandState: boolean;
  reportTitle: string;
  reportContent?: React.JSX.Element[];
  shouldExpand?: boolean;
  isInsideExpand?: boolean;
  calendarSelectedDay?: ShiftSegment | null;
  setCalendarSelectedDay?: (shift: ShiftSegment | null) => void;
};

export type MultiDayReportConfigType = {
  /** Sunday = 0, Monday = 1, etc */
  startDayOfWeek: number;
  /** if not included, assume 7 day week */
  endDayOfWeek?: number;

  startHour: number;
  startMinute: number;

  /** if not included, use startHour */
  endHour?: number;
  /** if not included, use startMinute */
  endMinute?: number;
};

export type WeeklyReportConfigType = MultiDayReportConfigType & {
  /** list of machineGroups to show weekly reports, if not included use machineGroups */
  machineGroups?: string[];
  /** use custom report title if supplied */
  reportTitle?: string;
  /** default = 5 */
  numOfWeeks?: number;
};

export enum ReportScheduleType {
  SHIFTLY = "shiftly",
  DAILY = "daily",
  WEEKLY = "weekly",
  MONTHLY = "monthly",
}

export type CustomReportWithSchedule = {
  reportTitle: string;
  reportPath: string;
  reportScheduleType: ReportScheduleType;
  reportGroups?: string[];
  multiDayReportConfig?: MultiDayReportConfigType[];
};
